'use strict';

angular.module('client.services').factory('standardsService', ['$resource', 'api_server',
  function ($resource, api_server) {

  var templateExpectationsResource =
    $resource(api_server + '/experience_templates/:template_id/set/:set_id/grade/:grade_id/expectations', {},
      {get: {method: 'GET', isArray: true, params: {template_id: '@template_id', set_id: '@set_id', grade_id: '@grade_id'}}});

  var templateBreakoutsResource =
    $resource(api_server + '/experience_templates/:id/breakouts', {},
        {get: {method: 'GET', isArray: true, params: {id: '@id'}}});

  var templateSceneExpectationsResource =
    $resource(api_server + '/experience_templates/:template_id/set/:set_id/grade/:grade_id/scene_expectations', {},
        {get: {method: 'GET', params: {template_id: '@template_id', set_id: '@set_id', grade_id: '@grade_id'}}});

    var templateElementExpectationsResource =
    $resource(api_server + '/experience_templates/:template_id/elements/:element_id/set/:set_id/grade/:grade_id/expectations', {},
      { get: { method: 'GET', isArray: true, params: { template_id: '@template_id', element_id: '@element_id', set_id: '@set_id', grade_id: '@grade_id' } } });

  function templateExpectations(template_id, set_id, gradeId) {
    return templateExpectationsResource.get({template_id: template_id, set_id: set_id, grade_id: gradeId});
  }

  function templateBreakouts(id) {
    return templateBreakoutsResource.get({id: id});
  }

  function sceneExpectations(template_id, set_id, gradeId) {
    return templateSceneExpectationsResource.get({template_id: template_id, set_id: set_id, grade_id: gradeId});
  }

  function elementExpectations(experienceTemplateId, elementTemplateId, setId, gradeId) {
    return templateElementExpectationsResource.get({ template_id: experienceTemplateId, element_id: elementTemplateId, set_id: setId, grade_id: gradeId });
  }

  return {
    templateExpectations: templateExpectations,
    templateBreakouts: templateBreakouts,
    sceneExpectations: sceneExpectations,
    elementExpectations: elementExpectations
  };
}]);
